import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted, onUnmounted, computed } from 'vue';

// 滚动位置状态

export default /*@__PURE__*/_defineComponent({
  __name: 'BackToTop',
  setup(__props) {

const scrollPosition = ref(0);

// 当滚动超过300px时显示回到顶部按钮
const showBackToTop = computed(() => scrollPosition.value > 300);

// 滚动到顶部的函数
const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};

// 处理滚动事件
const handleScroll = () => {
  scrollPosition.value = window.scrollY;
};

// 生命周期钩子
onMounted(() => {
  window.addEventListener('scroll', handleScroll);
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("button", {
    onClick: scrollToTop,
    class: "fixed bottom-6 right-6 w-12 h-12 rounded-full bg-black/70 text-white flex items-center justify-center cursor-pointer hover:bg-black transition-all duration-300 z-50",
    "aria-label": "回到顶部"
  }, " ↑ ", 512)), [
    [_vShow, showBackToTop.value]
  ])
}
}

})